import { FC, Fragment } from 'react';
// components
import StaffDashboard from './Staff';
import AdminDashboard from './Admin';
import SuperDashboard from './SuperAdmin';
// helper, context
import { useAuthContext } from 'contexts/AuthContext';
import { isSuperAdmin, isAdmin, isStaff } from 'lib/helper';

const DashboardContent: FC = (): JSX.Element => {
  const { userRoles } = useAuthContext();
  const isSuper = isSuperAdmin(userRoles);
  const isOrgAdmin = isAdmin(userRoles);
  const isOrgStaff = isStaff(userRoles);

  return (
    <Fragment>
      {isSuper && <SuperDashboard />}
      {isOrgAdmin && <AdminDashboard />}
      {isOrgStaff && <StaffDashboard />}
    </Fragment>
  );
};

export default DashboardContent;
